const projectPermissions = {
    customerPerms: "customer",
    canViewOrderDeliveryData: 'orders.delivery.information',
    canViewCoWorkerOrderList: 'order.coworker.view',
    canViewCustomerOrderList: 'order.customer.view',
    canEditOrderDeliveryMethod: 'orders.delivery',
    canEditOrderAddress: 'orders.address',
    canRejectOrder: 'orders.reject',
    canRemoveProductFromOrder: 'orders.items.remove',
    canAccessFinancialCode: 'orders.item.financial_code',
    canViewLogs: 'log',
    canViewPersonnelLogs: 'personnel.log',
    canViewInvoicesList: 'invoices.view',
    canViewOrderPricing: 'orders.item.pricing',
    payInvoice: "invoices.pay",
    editOrDeleteInvoice: "invoices.manage",
    showInvoice: "invoices.view",
    invoiceList: "invoices.list",
    dashboard: "dashboard",
    articleCategory: 'article.category',
    article: 'article',
    commercialPartners: 'commercial.partners',
    productCategory: 'product.category',
    productFeature: 'product.feature',
    product: 'product',
    gallery: "gallery",
    features: 'features',
    sliderManagement: "slider",
    bannerManagement: "banner",
    faqManagement: "faqs",
    guideManagement: "guides",
    menuManagement: "menu.set",
    settingManagement: "setting",
    mediaManagement: "media",
    rolesManagement: "role_permission",
    customerManagement: "customer.manage",
    couponManagement: "coupon",
    deliveryManagement: "delivery",
    smsManagement: "sms.manage",
    commentsManagement: "comments",
    withdrawRequestsManagement: "",
    editProfile: "profile",
    stories: "story",
    galleries: "galleries",
    contact: "contact",
    seo: "seo",
    productGroupOffer: "product.group-offers",
    customerBrand: "customer.brand",
    staffManagement: "staff.manage",
    brand: "brands",
    tags: "tags",
    salesConsultant: "affiliate-program",
    transaction: "transactions",
    serviceCategories: "services.categories",
    services: "services",
    catalogCategories: "catalogs.categories",
    catalog: "catalogs",
    attribute: "attributes",
    ReservationRequest: "reservation-requests",
    adminPay: "admin-payment",
    wallet: "wallet",
    warehouse: "warehouse",
    coWorker: "co_worker",
    //customer club permission
    club: "customer_club",
    clubCampaign: "customer_club",
    rating: "customer_club",
    isClub: "orders.store",
    formulas: "formulas",
    fields: "fields",
    variables: "variables"
}

export default projectPermissions

/*
        'web',
        'pay.wallet',
        'comments',
        'sms.manage',
        'menu.set',
        'general',
        'dashboard',
        'setting',
        'article.category',
        'article',
        'slider',
        'mainContentCard',
        'banner',
        'icons',
        'faqs',
        'guides',
        'invoices.view',
        'invoices.list',
        'invoices.manage',
        'invoices.pay',
        'admin.info',
        'features',
        'delivery',
        'gateway',
        'media',
        'role_permission',
        'references',
        'customer.manage',
        'piece.category',
        'piece.features',
        'piece',
        'door.category',
        'door.piece',
        'door',
        'coupon',
        'coupon.user',
        'log',
        'customer',
        'filters',
        'orders.list.preview',
        'orders.delivery.information',
        'orders.items',
        'orders.item.edit',
        'orders.item.pricing',
        'orders.reject',
        'orders.items.remove',
        'orders.reference',
        'orders.logs',
        'orders.delivery',
        'orders.address',
        'produce',
        'discharge',
        'exports
 */
